import { css } from '@linaria/atomic'
import { styled } from '@linaria/react'
import { getThemeSpacing } from '../../styles/appTheme'
import {
    maxWindowWidth,
    smallHeightDialogCheck,
} from '../../styles/breakpoints'
import { palette } from '../../styles/colors'

export const MOBILE_SEARCH_HEIGHT = 84
export const DESKTOP_SEARCH_HEIGHT = 50

export const titleStyles = css`
    font: inherit;
    align-items: center;
    font-weight: 600;
    display: flex;
    width: 100%;
    font-size: 0.7rem;
    color: ${palette.drawerLabel};
    padding-bottom: ${getThemeSpacing(0.5)};
    ${maxWindowWidth(370)} {
        font-size: 0.6rem;
    }
`

export const StyledResponsiveGrid = styled('div')`
    display: grid;
    height: 100%;
    overflow-y: auto;
    padding-left: ${getThemeSpacing(1)};
    padding-right: ${getThemeSpacing(1)};
    padding-bottom: ${getThemeSpacing(1)};
    padding-top: 4px;
    column-gap: ${getThemeSpacing(1)};
`

export const noResultStyles = css`
    width: 100%;
    height: 100%;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    padding-top: 0;
    text-shadow: 0px 0px 6px ${palette.background};
    ${smallHeightDialogCheck} {
        height: 240px;
    }
`

export const StyledFormControl = styled('div')`
    display: flex;
    flex-direction: column;
    position: relative;
    padding-bottom: ${getThemeSpacing(1)};
    min-width: 120px;
    width: 100%;
    font-size: 13px;
`

export const modelNameStyles = css`
    font-size: 14px;
    font-weight: 600;
`
